export const appOptions = {
  apiUrl: process.env.REACT_APP_API_URL,
  storageKey: 'user',
  languageKey: 'currentLanguage',
};



// WEBPACK FOOTER //
// ./src/config/app.js